
import {  CATEGORYS_REQUEST,
  CATEGORYS_SUCCESS,
  CATEGORYS_FAILURE, } from "../actions/actionTypes";

const initialState = {
  categorys: [],
  loading: false,
  error: null,
};

const categorysReducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORYS_FAILURE:
      return { ...state, loading: true, error: null };
      
    case CATEGORYS_REQUEST:
      return { ...state, loading: false, categorys: action.payload.data };

    case CATEGORYS_SUCCESS:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default categorysReducer;
